import { get } from 'lodash'

import { getExpandedPath, getPathString } from '@helpers'
import { ObjectDataRecord } from '@types'

import { EmbeddedObject } from '@gantt/components/GanttCreateOrEdit'

export const groupDataByField = (data: {
  groupField: EmbeddedObject[]
  objectData: ObjectDataRecord[]
}) => {
  const { objectData, groupField } = data

  const groups = new Map<string, { data: ObjectDataRecord[]; meta: ObjectDataRecord }>()

  objectData.forEach(element => {
    const groupKey = get(element, getExpandedPath(getPathString(groupField as EmbeddedObject[]))) // Получаем значение поля, по которому группируем

    if (!groups.has(groupKey)) {
      groups.set(groupKey, {
        meta: element,
        data: [],
      })
    }

    groups.get(groupKey)!.data.push(element)
  })

  return groups
}
